import { ISearchTreeParams, ISearchTreeResult } from '../../types'
import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export class TargetedMoietyTypeApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async searchTree(params: ISearchTreeParams): Promise<IHttpWrap<ISearchTreeResult>> {
    return this.http({
      url: this.getUrl('pharmsnap_webapi/1.0/dictionary/targeted_moiety/search'),
      data: params,
      method: 'POST',
      cache: true,
    })
  }
}
